<div
  class="scalable-container"
  [style.transform]="'scale(' + scale + ')'"
  [style.transformOrigin]= "getTransformOrigin()"
>
  <div class="vertical-progress-tracker">
    <ul class="list-unstyled">
      <li
        *ngFor="let step of steps; let i = index"
        class="progress-step d-flex align-items-center"
      >
        <div class="pill-container">
          <div
            class="pill"
            [ngClass]="{
              'step-default': step.state === 'default',
              'step-active': step.state === 'active',
              'step-completed': step.state === 'completed',
            }"
          >
            <i
              *ngIf="step.state === 'completed'"
              class="bi bi-check-lg"
              style="font-size: 1.75rem"
            ></i>
            <div
              class="inner-circle"
              [ngClass]="{
                'inner-circle-default': step.state === 'default',
                'inner-circle-active': step.state === 'active',
                'inner-circle-completed': step.state === 'completed',
              }"
            ></div>
          </div>
          @if (i < steps.length - 1) {
            <div class="vertical-line"></div>
          }
        </div>
        <div
          class="step-label"
          [ngClass]="{
            'step-default': step.state === 'default',
            'step-active': step.state === 'active',
            'step-completed': step.state === 'completed',
          }"
        >
          {{ step.label }}
        </div>
      </li>
    </ul>
  </div>

  <div class="horizontal-progress-tracker">
    <div class="progress-bar">
      <div
        *ngFor="let step of filteredSteps; let i = index"
        class="progress-step"
      >
        @if (i === 0) {
          <div class="line left-short-line"></div>
        }
        <!-- Step Indicator -->
        <div
          class="pill"
          [ngClass]="{
            'step-default': step.state === 'default',
            'step-active': step.state === 'active',
            'step-completed': step.state === 'completed',
          }"
        >
          <i *ngIf="step.state === 'completed'" class="bi bi-check-lg"></i>
          <div
            class="inner-circle"
            [ngClass]="{
              'inner-circle-default': step.state === 'default',
              'inner-circle-active': step.state === 'active',
              'inner-circle-completed': step.state === 'completed',
            }"
          ></div>
        </div>

        <!-- Horizontal Line (Between Steps) -->
        <div *ngIf="i < filteredSteps.length - 1" class="horizontal-line"></div>

        <!-- Step Label -->
        <p class="step-label">{{ step.label }}</p>

        @if (i == filteredSteps.length - 1) {
          <div class="line right-short-line"></div>
        }
       
      </div>
      
    </div>
  </div>
</div>
